module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_6.86b6c474.png";